<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9Jtwon/tc-custom/9781504076814.jpg?1705201764193" alt="This image is the cover for the book Adam Black Thrillers Books One to Five, The Adam Black Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Adam Black Thrillers Books One to Five, The Adam Black Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>Five novels of action and suspense in one volume, featuring the special forces veteran who’s now a lawyer—but still combat-ready.</b><br/><br/><b><i>Unleashed</i></b><br/> An ex-SAS captain fights back and survives a violent attack in his quiet Scottish village—only to wind up with himself and his family in the crosshairs of a vengeful Glaswegian gangster . . .<br/><br/><b><i>Violation</i></b><br/> When Adam Black learns he’s the sole beneficiary of a stranger’s will, the puzzling legacy is shrouded in mystery. To find the truth behind it, he will travel a violent and treacherous path that leads to devastating consequences—and forces him to resort to his expertise in killing for survival.<br/><br/><b><i>Venomous</i></b><br/> The prime minister’s daughter has been abducted, and to gain crucial information from a psychopath nicknamed the Red Serpent, Black must infiltrate one of Scotland’s toughest prisons.<br/><br/><b><i>Fury</i></b><br/> A stranger gives Black a book, claiming it holds the key to his wife’s murder. A Hollywood actor filming in Glasgow makes a strange request that throws Black’s life into turmoil. And a long-dormant killer re-emerges with gruesome results. All will entangle Black in his most mysterious case yet . . .<br/><br/><b><i>Finale</i></b><br/> Black investigates an old friend’s murder as a favor to his grieving widow—but as he plunges into a mystery involving money laundering and human trafficking, he may go to his own grave without any answers . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karl Hill
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ef9867d